import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import setUiMessage from '../../../Utilities/Tostify';

import { post } from '../../Auths/AuthToken';
import {
  bookNewAppWithApp,
  setAppPopup,
  setGlobalAppId,
  setIsCheckoutProcess,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';

function AppStatusPopup(props) {
  const {
    appId,
    appStatus,
    typeOfVisit,
    vCrtOrNot,
    setStatusPopup,
    handleReload,
    futureApp,
    futureAppData,
    treatment_plan_mode,
  } = props;
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const [allData, setAllData] = useState(null);
  const [providerList, setProviderList] = useState(null);
  const [resourceList, setResourceList] = useState(null);
  const [refProviderList, setRefProviderList] = useState(null);
  const [paymentStatusList, setPaymentStatusList] = useState(null);

  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedProviderChange, setSelectedProviderChange] = useState('');
  const [selectedRecource, setSelectedRecource] = useState('');
  const [selectedRecourceChange, setSelectedRecourceChange] = useState('');
  const [selectedRefPro, setSelectedRefPro] = useState('');
  const [selectedRefProChange, setSelectedRefProChange] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [telemed, setTelemed] = useState('');

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/getActionListOfSpecificStatus',
          {
            appointmentId: appId,
            status: parseInt(appStatus) === (16 || 17) ? 7 : appStatus,
            typeOfVisit: typeOfVisit,
            vCrtOrNot: vCrtOrNot,
            treatmentVisit: treatment_plan_mode ? treatment_plan_mode : 0,
            staffUserId: user?.id,
          }
        );

        if (response?.status === 200) {
          setAllData(response?.data);
          setProviderList(response?.data?.allProvider);
          setResourceList(response?.data?.allResourceWithCode);
          setRefProviderList(response?.data?.refDrList);
          setPaymentStatusList(response?.data?.payment_status_master);
          setPaymentStatus(response?.data?.selectedPaymentType);
          setSelectedRefPro(response?.data?.selectedRefProv);
          setSelectedRecource(response?.data?.selectedResource);
          setSelectedProvider(response?.data?.selectedProvider);
          setTelemed(response?.data?.telemedicine);
          setSelectedProviderChange(response?.data?.selectedProvider);
          setSelectedRecourceChange(response?.data?.selectedResource);
          setSelectedRefProChange(response?.data?.selectedRefProv);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [
    dispatch,
    appId,
    appStatus,
    typeOfVisit,
    vCrtOrNot,
    treatment_plan_mode,
    user?.id,
  ]);

  const handlePaymentStatusChange = (e) => {
    setDialogOpen('payment');
    setPaymentStatus(e.target.value);
  };
  const handlePaymentSuccess = () => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/updatePatientPaymentStatus',
          {
            patientId: allData?.patientId,
            paymentStatusId: paymentStatus,
            appId: allData?.appointmentId,
            visitId: '',
          }
        );

        if (response?.status === 200) {
          if (response?.data?.status === 'success') {
            setDialogOpen(false);
            setUiMessage('suc', 'Payment status change successfully.');
          } else if (response?.data?.status === 'billGenerate') {
            setDialogOpen(false);
            setUiMessage(
              'inf',
              'Bill already generated so status cannot be changed.'
            );
          } else {
            setDialogOpen(false);
            setUiMessage('war', 'Failed!');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleChangeProvider = (e) => {
    setDialogOpen('provider');
    setSelectedProvider(e.target.value);
  };

  const handleProviderSuccess = () => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/updateProviderFromPop',
          {
            staffUserId: user?.id,
            appointmentId: allData?.appointmentId,
            resId: selectedProvider,
          }
        );

        if (response?.status === 200) {
          if (response?.data?.status === 'success') {
            setSelectedProviderChange(selectedProvider);
            setDialogOpen(false);
            setUiMessage('suc', 'Provider change successfully.');
          } else if (response?.data?.status === 'fail') {
            setDialogOpen(false);
            setUiMessage('war', 'Failed!');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleResourceChange = (e) => {
    setDialogOpen('resource');
    setSelectedRecource(e.target.value);
  };

  const handleResourceSuccess = () => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/updateResourceFromPop',
          {
            staffUserId: user?.id,
            appointmentId: allData?.appointmentId,
            resId: selectedRecource,
            code: '',
          }
        );

        if (response?.status === 200) {
          if (response?.data?.status === 'success') {
            setSelectedRecourceChange(selectedRecource);
            setDialogOpen(false);
            setUiMessage('suc', 'Resource change successfully.');
          } else if (response?.data?.status === 'fail') {
            setDialogOpen(false);
            setUiMessage('war', 'Failed!');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleRefProChange = (e) => {
    setDialogOpen('refPro');
    setSelectedRefPro(e.target.value);
  };
  const handleRefProviderSuccess = () => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/referringProviderFromPop',
          {
            staffUserId: user?.id,
            appointmentId: allData?.appointmentId,
            selRefProId: selectedRefPro,
          }
        );

        if (response?.status === 200) {
          if (response?.data?.status === 'success') {
            setSelectedRefProChange(selectedRefPro);
            setDialogOpen(false);
            setUiMessage('suc', 'Ref. provider change successfully.');
          } else if (response?.data?.status === 'fail') {
            setDialogOpen(false);
            setUiMessage('war', 'Failed!');
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleStatusChange = async (e) => {
    try {
      const response = await post(
        'api/appointment/Appointment/saveOrRemoveFromSessionForStatusProcess',
        {
          addOrRemove: 1,
          patient_id: allData?.patientId,
          current_status_id: parseInt(appStatus) === (16 || 17) ? 7 : appStatus,
          visitId: '',
          appointmentId: allData?.appointmentId,
          currentStatusAutoIncId: allData?.currentStatusAutoIncId,
          fromWhere: '',
          crt_v_y_n: vCrtOrNot,
          treatmentMode: treatment_plan_mode || 0,
          wizardCheckbox: '',
          progressNoteCheckbox: '',
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        if (response?.data?.status === 'success') {
          handleStatusUpdate();
        } else {
          setUiMessage('inf', 'Unable to change appointment status.');
        }
        setStatusPopup(false);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleStatusUpdate = (a, b, c, d) => {
    if (parseInt(appStatus) === 5 && parseInt(vCrtOrNot) === 1) {
      navigate(
        `${DEFAULT_LOCAL_PATH}/patient/counNote/${allData?.patientId}/${allData?.appointmentId}/${allData?.visitId}`
      );
    } else if (
      parseInt(appStatus) === 5 &&
      parseInt(treatment_plan_mode) === 1
    ) {
      navigate(
        `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${allData?.patientId}/${allData?.appointmentId}/${allData?.visitId}/${allData?.treatmentId}`
      );
    } else {
      (async () => {
        try {
          const response = await post(
            'api/appointment/Appointment/changeCurrentStatus',
            {
              appointmentId: allData?.appointmentId,
              currentStatusId:
                parseInt(appStatus) === (16 || 17) ? 7 : appStatus,
              currentStatusAutoIncId: allData?.currentStatusAutoIncId,
              patient_id: allData?.patientId,
              loginUserId: user?.id,
              recurringVal: 0,
              reason: '',
            }
          );
          if (response?.status === 200) {
            if (response?.data?.successCode === 1) {
              if (parseInt(appStatus) === 11) {
                navigate(
                  `${DEFAULT_LOCAL_PATH}/patient/profile/${allData?.patientId}`
                );
                // } else if (parseInt(appStatus) === 5) {
                //   navigate(
                //     `${DEFAULT_LOCAL_PATH}/patient/screening/${allData?.patientId}`
                //   );
              } else {
                handleReload();
              }
              setUiMessage('suc', 'Appointment status change successfully.');
            } else {
              setUiMessage('inf', 'Unable to change appointment status.');
            }
            setStatusPopup(false);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    }
  };

  const handleCheckOutStatusUpdate = async () => {
    try {
      const response = await post('api/appointment/appointment/chkFutureApp', {
        appId: allData?.appointmentId,
        patientId: allData?.patientId,
        loginUserId: user?.id,
        ncv: vCrtOrNot,
        patientName: allData?.patName,
      });
      if (response?.status === 200) {
        if (parseInt(response?.data?.futureApp) === 1) {
          futureApp();
          setStatusPopup(false);
          futureAppData({
            ...response?.data,
            curStatAutoIncId: allData?.currentStatusAutoIncId,
          });
        } else {
          dispatch(setAppPopup(true));
          dispatch(setGlobalAppId(appId));
          dispatch(
            bookNewAppWithApp({
              status: true,
            })
          );
          dispatch(
            setIsCheckoutProcess({
              status: true,
              appid: appId,
              curStatAutoIncId: allData?.currentStatusAutoIncId,
            })
          );
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleTelemedicine = (e) => {
    const { checked } = e.target;

    setTelemed(checked ? '1' : '0');
    if (checked) {
      handleTelemedicineSuccess('1');
    } else {
      handleTelemedicineSuccess('0');
    }
  };

  const handleTelemedicineSuccess = async (type) => {
    try {
      const response = await post(
        'api/patient/progressNote/updateAppointmentTelemedicine',
        {
          appointmentId: allData?.appointmentId,
          telemedicine: type,
          fieldId: 0, //it can be 0 or 1
          staffUserId: user?.id,
        }
      );

      if (response?.status === 200) {
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleUpdateProviderCancel = () => {
    if (selectedProviderChange === allData?.selectedProvider) {
      setSelectedProvider(allData?.selectedProvider);
    } else {
      setSelectedProvider(selectedProviderChange);
    }
    setDialogOpen(false);
  };

  const handleUpdateResourceCancel = () => {
    if (selectedRecourceChange === allData?.selectedResource) {
      setSelectedRecource(allData?.selectedResource);
    } else {
      setSelectedRecource(selectedRecourceChange);
    }
    setDialogOpen(false);
  };

  const handleUpdateRefProviderCancel = () => {
    if (selectedRefProChange === allData?.selectedRefProv) {
      setSelectedRefPro(allData?.selectedRefProv);
    } else {
      setSelectedRefPro(selectedRefProChange);
    }
    setDialogOpen(false);
  };

  return (
    <div className="modalBackground" style={{ zIndex: '10' }}>
      <div className="schdlr-actn-pop-up">
        <div className="sap-hdr">
          <h3>{allData?.status}</h3>
        </div>
        <div className="schdlr-actn-pop-up-rw">
          <div className="scdlr-Pt-pic">
            <img
              style={{ height: '73px' }}
              width="100%"
              src={
                allData?.photograph ? allData?.photograph : './images/user.jpg'
              }
              alt=""
            />
          </div>
          <div className="scdlr-Pt-info sap-col-1">
            <div className="scdlr-Pt-info-rw">
              <span className="sap-pt-nm">{allData?.patName}</span>
            </div>
            <div className="scdlr-Pt-info-rw">
              <span className="sap-pt-info">
                {`(ID: ${allData?.chart_number}), ${allData?.gender}-${allData?.age}`}
              </span>
            </div>
            <div className="scdlr-Pt-info-rw">
              <span className="sap-pt-info">DOB: {allData?.dob}</span>
            </div>
          </div>
          <div className="scdlr-Pt-info stats-popup-tov">
            {/* <div className="scdlr-Pt-info-rw">
             <span className="sap-pt-info" style={{ marginTop: '-8px' }}>
                {' '}
                LoremIpsum Loremipsum lorem ipsum
              </span> 
              <span className="bold orange-text" style={{ fontSize: '8px' }}>
                &#128222;
              </span>
            </div>*/}
            <div className="scdlr-Pt-info-rw">
              <span className="sap-pt-info" style={{ marginTop: '3px' }}>
                Payment Type:
              </span>
              <span className="sap-pt-info margin0">
                <select
                  className="sap-pymnt-dd margin0"
                  value={paymentStatus}
                  onChange={handlePaymentStatusChange}
                >
                  <option value="">Select</option>
                  {paymentStatusList &&
                    paymentStatusList.map((item, idx) => {
                      return (
                        <option key={idx} value={item?.id}>
                          {item?.title}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
            <span className="sap-pt-info">
              Dues: <b className="red">{allData?.patBal}</b>
            </span>
          </div>
        </div>
        <div className="schdlr-actn-pop-up-rw">
          <span className="maroon" style={{ flexBasis: '78%' }}>
            <span className="sap-pt-info"> Visit type:</span>
            {allData?.typeOfVisit}
          </span>
          <span className="">
            <input
              type="checkbox"
              className="clear-top5"
              checked={telemed === '1' ? true : false}
              onChange={handleTelemedicine}
            />
            <span className="qsap-pt-info clear-left10">Telemedicine</span>
          </span>
        </div>
        <div className="schdlr-actn-pop-up-rw">
          <span className="dgrid width100">
            <span className="sap-pt-info">Provider</span>
            <select
              className="sap-dd"
              value={selectedProvider}
              onChange={handleChangeProvider}
            >
              <option value="">Select</option>
              {providerList &&
                providerList.map((item, idx) => {
                  return (
                    <option key={idx} value={item?.id}>
                      {item?.provName}
                    </option>
                  );
                })}
            </select>
          </span>
          <span className="dgrid width100">
            <span className="sap-pt-info">Resource</span>
            <select
              className="sap-dd"
              value={selectedRecource}
              onChange={handleResourceChange}
            >
              <option value="">Select</option>
              {resourceList &&
                resourceList.map((item, idx) => {
                  return (
                    <option key={idx} value={item?.id}>
                      {item?.resName}
                    </option>
                  );
                })}
            </select>
          </span>
          <span className="dgrid width100">
            <span className="sap-pt-info">Ref. Provider</span>
            <select
              className="sap-dd"
              value={selectedRefPro}
              onChange={handleRefProChange}
            >
              <option value="">Select</option>
              {refProviderList &&
                refProviderList.map((item, idx) => {
                  return (
                    <option key={idx} value={item?.id}>
                      {item?.name}
                    </option>
                  );
                })}
            </select>
          </span>
        </div>
        <div className="schdlr-actn-pop-up-rw">
          <span className="sap-pt-info fs1-4">
            Your current preferences under{' '}
            <span className="orange-txt bold">{allData?.status}</span> includes:
          </span>
        </div>

        <div className="schdlr-actn-pop-up-rw">
          <ol className="sap-list-style">
            {(parseInt(allData?.currentStatus) === 11 && (
              <>
                <li className="">Update Patients Demographics</li>
                <li className="">Update Patient Settings</li>
                <li className="">Update Patient Insurance</li>
              </>
            )) ||
              (parseInt(allData?.currentStatus) === 5 && (
                <li className="">Continue with {allData?.typeOfVisit}</li>
              )) ||
              (parseInt(allData?.currentStatus) === 7 && (
                <>
                  <li>
                    Select "Continue" to schedule a follow-up Appointment..
                  </li>
                  <li>
                    Select "Check out" if you want to Check out without
                    scheduling a follow-up Appointment.
                  </li>
                </>
              ))}
          </ol>
        </div>

        <div
          className="schdlr-actn-pop-up-rw"
          style={{
            lineHeight: '20px',
            backgroundColor: '#fffff7',
            qborderBottom: '1px solid #f4f4d6',
            padding: '3px 0px',
          }}
        >
          <div className="scdlr-Pt-info sap-col-2">
            <span className="sap-pt-info">Payor [P]: {allData?.insName}</span>
            <span className="sap-pt-info">
              Payor [S]: {allData?.insNameSec}
            </span>
          </div>
          <div className="scdlr-Pt-info">
            <span className="sap-pt-info">
              Co-Pay: <b>{allData?.coPay}</b>
            </span>
            <span className="sap-pt-info">
              Sp. Co-Pay: <b>{allData?.spCoPay}</b>
            </span>
          </div>
        </div>
        <span className="logout-action">
          {parseInt(allData?.nextStatusId) === 9 &&
          (parseInt(vCrtOrNot) === 1 || parseInt(treatment_plan_mode) === 1) ? (
            <div>
              <button className="actn-yes" onClick={handleStatusChange}>
                Check out
              </button>
              <button className="actn-yes" onClick={handleCheckOutStatusUpdate}>
                Continue
              </button>
            </div>
          ) : (
            <button className="actn-yes" onClick={handleStatusChange}>
              Continue
            </button>
          )}
          <button className="actn-No" onClick={() => setStatusPopup(false)}>
            Cancel
          </button>
        </span>
      </div>
      {dialogOpen && dialogOpen === 'payment' && (
        <ConfirmDialog
          title="Do you want to change the payment status?"
          bodytext="Update payment status."
          closeDialog={() => setDialogOpen(false)}
          successDialog={handlePaymentSuccess}
        />
      )}
      {dialogOpen && dialogOpen === 'provider' && (
        <ConfirmDialog
          title="Do you want to change the provider?"
          bodytext="Update provider."
          closeDialog={handleUpdateProviderCancel}
          successDialog={handleProviderSuccess}
        />
      )}
      {dialogOpen && dialogOpen === 'resource' && (
        <ConfirmDialog
          title="Do you want to change the resource?"
          bodytext="Update resource."
          closeDialog={handleUpdateResourceCancel}
          successDialog={handleResourceSuccess}
        />
      )}
      {dialogOpen && dialogOpen === 'refPro' && (
        <ConfirmDialog
          title="Do you want to change the Referring  Provider?"
          bodytext="Update Provider."
          closeDialog={handleUpdateRefProviderCancel}
          successDialog={handleRefProviderSuccess}
        />
      )}
    </div>
  );
}

export default AppStatusPopup;
